import { useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { isNotEmpty } from "../../../helpers/StringHelpers"
import { Option } from "../../../services/ntuc/userService/staticData"
import { MonthlySalaryValidator } from "../../../services/validation/address-employment-form/MonthlySalaryField"
import { StaticDataContext } from "../../../views/signup-flow/SignupFormPage/SignupFormPage"
import { DropDown } from "../../DropDown/DropDown"
import { FormFieldProps } from "../../FormFieldProps/FormFieldProps"
import { disableFieldCheck } from "../../../services/validation/address-employment-form/disableFieldCheck"

const MonthlySalaryField = (props: FormFieldProps<Option>) => {
    const { t } = useTranslation(`signup`)
    const staticData = useContext(StaticDataContext)
    const [errorMessage, setErrorMessage] = useState(``)
    const [value, setValue] = useState(``)
    const {
        defaultValue,
        handleChange,
        errorText,
        dependentField,
    } = props

    useEffect(() => {
        if (disableFieldCheck.has(dependentField ?? ``)) {
            setValue(``)
            setErrorMessage(``)
            return
        }

        setErrorMessage(errorText ?? ``)

    }, [errorText, dependentField])

    const validateField = () => {
        const validator = new MonthlySalaryValidator()
        const validationText = t(validator.validate(value) ?? ``)
        setErrorMessage(validationText)
    }

    const handleOnChange = (option: Option) => {
        setValue(option.value)
        handleChange(option)
    }

    const defaultOption = staticData?.monthly_income?.find(
        (option) => option.code === defaultValue?.code,
    )

    return (
        <DropDown
            title={t(`monthly_gross_salary`)}
            options={staticData?.monthly_income ?? []}
            showError={isNotEmpty(errorMessage)}
            errorMessage={t(errorMessage)}
            defaultValue={defaultOption}
            onChange={handleOnChange}
            onBlur={validateField}
            dependentField={dependentField}
        />
    )
}

export { MonthlySalaryField }